import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import PlayerInfo from './PlayerInfo'
import FavIcon from './FavIcon'

export type AffiliationProps = {
    affiliation: string
    imageUrl?: string
    alt?: string
}

type PlayerName =
    | {
          /**
           * nick name of player (either nickName or first + lastName are required)
           * */
          nickName: string
          /**
           * first name of player (either nickName or first + lastName are required)
           * */
          firstName?: string
          /**
           * last name of player (either nickName or first + lastName are required)
           * */
          lastName?: string
      }
    | {
          /**
           * nick name of player (either nickName or first + lastName are required)
           * */
          nickName?: string
          /**
           * first name of player (either nickName or first + lastName are required)
           * */
          firstName: string
          /**
           * last name of player (either nickName or first + lastName are required)
           * */
          lastName: string
      }

export type SquadPlayerItemProps = PlayerName & {
    /**
     * url to player photo
     * */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    /**
     * age of player
     * */
    age?: number | string
    /**
     * jersey number of player
     * */
    jerseyNumber?: number | string
    /**
     * flag to show favorite icon in active state
     * */
    isFavorite?: boolean
    /**
     * first affiliation object comprised of 'affiliation' string and 'imageUrl'
     * */
    firstAffiliation: AffiliationProps
    /**
     * second affiliation object comprised of 'affiliation' string and 'imageUrl'
     * */
    secondAffiliation?: AffiliationProps
    /**
     * callback for press on whole component
     * */
    onPress?: () => void
    /**
     * callback for press on favorite icon
     * */
    onFavorite?: () => void
} & TestID

const SquadPlayerItem: FunctionComponent<SquadPlayerItemProps> = ({
    imageUrl,
    alt,
    firstName,
    lastName,
    nickName,
    age,
    jerseyNumber,
    isFavorite,
    firstAffiliation,
    secondAffiliation,
    onPress,
    onFavorite,
    testID,
}): ReactElement => {
    return (
        <Grid
            noExpand
            centerVertical
            height={80}
            backgroundColor="pearl"
            border={1}
            borderRadius={4}
            borderColor="moon-3"
            testID={testID}
        >
            <Grid horizontal {...(!onFavorite && { paddingRight: 5 })}>
                <Grid minWidth={0}>
                    <Touchable expand onPress={onPress}>
                        <PlayerInfo
                            {...{
                                imageUrl,
                                alt,
                                firstName,
                                lastName,
                                nickName,
                                age,
                                jerseyNumber,
                                firstAffiliation,
                                secondAffiliation,
                            }}
                        />
                    </Touchable>
                </Grid>
                {onFavorite ? <FavIcon {...{ isFavorite, onFavorite }} /> : null}
            </Grid>
        </Grid>
    )
}

export default SquadPlayerItem
